export class CecTable {
  content: string;
  type: CecTableType;
  adminStatus: CecTableAdminStatus;
  status: CecTableStatus;
  enabled: boolean;
  orTable: string

  constructor(
    content = '',
    type = CecTableType.NORMAL,
    adminStatus = CecTableAdminStatus.OK,
    status = CecTableStatus.OK,
    enabled = false,
    orTable = null,
  ) {
    this.content = content;
    this.type = type;
    this.adminStatus = adminStatus;
    this.status = status;
    this.enabled = enabled;
    this.orTable = orTable;
  }
}

export enum CecTableType {
  NORMAL, LIFESTAMP
}

export enum CecTableAdminStatus {
  OK, YESORNOT, CANCELLED, OR
}

export enum CecTableStatus {
  OK, MISSING, MORE, OR
}
